import React from "react";

function SuccessIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill="#27A435"
        d="M10.525 14.275l-2.45-2.45a.748.748 0 00-.55-.225c-.217 0-.4.075-.55.225a.804.804 0 00-.25.588c0 .224.075.412.225.562l3.05 3.05a.71.71 0 00.525.2.71.71 0 00.525-.2l6-6a.748.748 0 00.225-.55.79.79 0 00-.25-.575.763.763 0 00-.563-.225.804.804 0 00-.587.25l-5.35 5.35zM12 22c-1.417 0-2.733-.254-3.95-.762a9.761 9.761 0 01-3.175-2.113 9.76 9.76 0 01-2.112-3.175C2.254 14.733 2 13.417 2 12c0-1.4.254-2.708.763-3.925A9.76 9.76 0 014.875 4.9c.9-.9 1.958-1.608 3.175-2.125C9.267 2.258 10.583 2 12 2c1.4 0 2.708.258 3.925.775A9.927 9.927 0 0119.1 4.9c.9.9 1.608 1.958 2.125 3.175C21.742 9.292 22 10.6 22 12c0 1.417-.258 2.733-.775 3.95a9.927 9.927 0 01-2.125 3.175 9.76 9.76 0 01-3.175 2.113C14.708 21.745 13.4 22 12 22z"></path>
    </svg>
  );
}

export default SuccessIcon;
